import api, { ApiResponse } from './api';

export interface Partner {
  id: string;
  workspace_id: string;
  name: string;
  api_key: string;
  status: string;
  config: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export const partnersService = {
  list: async (): Promise<Partner[]> => {
    const response = await api.get<ApiResponse<Partner[]>>('/partners');
    return response.data.data!;
  },

  query: async (filters: { search?: string; limit?: number; offset?: number; statuses?: string[] } = {}): Promise<{ data: Partner[]; total: number }> => {
    const response = await api.post<ApiResponse<Partner[]> & { _meta?: { total: number } }>('/partners/query', filters);
    return { data: response.data.data!, total: response.data._meta?.total ?? 0 };
  },

  getById: async (id: string): Promise<Partner> => {
    const response = await api.get<ApiResponse<Partner>>(`/partners/${id}`);
    return response.data.data!;
  },

  create: async (data: { name: string; workspace_id?: string }): Promise<Partner> => {
    const response = await api.post<ApiResponse<Partner>>('/partners', data);
    return response.data.data!;
  },

  update: async (id: string, data: Partial<Pick<Partner, 'name' | 'status'>>): Promise<Partner> => {
    const response = await api.patch<ApiResponse<Partner>>(`/partners/${id}`, data);
    return response.data.data!;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/partners/${id}`);
  },
};
